import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import Swal from 'sweetalert2';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';

import { EmpresaService } from 'src/app/pages/services/empresas.service';
import { AdelantosService } from 'src/app/pages/services/adelantos/adelantos.service';
import { BancoService } from 'src/app/pages/services/banco/banco.service';
import { TrabajadoresService } from 'src/app/pages/services/trabajadores/trabajadores.service';
import { AlertHelper } from 'src/app/shared/components/helpers/alert.helpers';
import { Adelantos } from 'src/app/shared/models/adelantos.interface';
import { MatSelectChange } from '@angular/material/select';

@Component({
  selector: 'app-lista-adelantos',
  templateUrl: './lista-adelantos.component.html',
  styleUrls: ['./lista-adelantos.component.css'],
  providers: [DatePipe]
})
export class ListaAdelantosComponent implements OnInit {
  @Input() textoBuscar: string;
  @Input() adelantos_list: Adelantos[] = [];
  @Output() onDebounce: EventEmitter<boolean> = new EventEmitter();

  addressForm: FormGroup;

  update_adelantos: any = {
    id: 0,
    fechaInicioContrato: "",
    fk_trabajador: "",
    empresa: "",
    banco: "",
    tipoCuenta: "",
    numeroCuenta: 0,
    montoAdelanto: 0,
  };

  empresa_seleccionado: any;
  debouncer: Subject<boolean> = new Subject();
  displayedColumns: string[] = ['fechaInicioContrato', 'fk_trabajador', 'empresa', 'banco', 'numeroCuenta', 'montoAdelanto', 'actions'];
  dataSource = new MatTableDataSource<Adelantos>(this.adelantos_list);

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  bancos: any;
  empresas: any;
  trabajadores: any;
  modalReference: any = null;

  dateRangeForm = this.fb.group({
    start: [null],
    end: [null],
    empresa: [null]
  });

  constructor(
    private fb: FormBuilder,
    private alert: AlertHelper,
    private adelantoService: AdelantosService,
    private modalService: NgbModal,
    private bancoService: BancoService,
    private trabajadoresService: TrabajadoresService,
    private empresaService: EmpresaService,
    private datePipe: DatePipe
  ) {
    // Inicializar el formulario reactivo
    this.addressForm = this.fb.group({
      id: [null],
      fk_trabajador: [null, Validators.required],
      fechaInicioContrato: [null, Validators.required],
      empresa: [null, Validators.required],
      banco: [null, Validators.required],
      tipoCuenta: [null, Validators.required],
      numeroCuenta: [null, Validators.required],
      montoAdelanto: [null, Validators.required]
    });
  }

  ngOnInit(): void {
    this.debouncer
      .pipe(debounceTime(500))
      .subscribe(valor => {
        this.onDebounce.emit(valor);
      });

    this.loadEmpresas();
    this.loadTrabajadores();
    this.loadBancos();
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log(this.textoBuscar);

    if (changes.textoBuscar && this.textoBuscar) {
      const filtro = this.textoBuscar.trim().toLowerCase();
      this.dataSource.filter = filtro;

      this.dataSource.filterPredicate = (data: any, filter: string) => {
        const valores = [
          data.Trabajador.rut?.toString(),
          data.Trabajador.nombres,
          data.Trabajador.apellidos,
          data.Empresa?.nombre,
          data.Banco?.nombre,
          data.numeroCuenta?.toString(),
          data.montoAdelanto?.toString()
        ].join(' ').toLowerCase();

        return filter.split(' ').every(palabra => valores.includes(palabra));
      };
    }

    if (changes.adelantos_list) {
      this.dataSource = new MatTableDataSource<Adelantos>(this.adelantos_list);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }
  }

  loadEmpresas() {
    this.empresaService.traerEmpresas().subscribe(res => {
      this.empresas = res.data;
    });
  }

  loadTrabajadores() {
    this.trabajadoresService.TraerTrabajadores().subscribe(res => {
      this.trabajadores = res.data;
    });
  }

  loadBancos() {
    this.bancoService.traerTodosLosBancos().subscribe(res => {
      this.bancos = res.data;
    });
  }

  open(content: any, id: number) {
    this.adelantoService.obtenerAdelantoPorId(id).subscribe(res => {
      this.update_adelantos = res.data;

      // Llenar el formulario con los datos actuales del adelanto
      this.addressForm.patchValue({
        fk_trabajador: this.update_adelantos.fk_trabajador,
        fechaInicioContrato: this.update_adelantos.fechaInicioContrato,
        empresa: this.update_adelantos.empresa,
        banco: this.update_adelantos.banco,
        tipoCuenta: this.update_adelantos.tipoCuenta,
        numeroCuenta: this.update_adelantos.numeroCuenta,
        montoAdelanto: this.update_adelantos.montoAdelanto,
        id: this.update_adelantos.id
      });
      console.log("a update: ", this.update_adelantos)
      this.modalReference = this.modalService.open(content);
    });
  }

  actualizar_adelanto() {
    console.log("actualizando el siguiente adelanto: ", this.update_adelantos)

    if (this.addressForm.valid) {
      this.update_adelantos = this.addressForm.value;
      this.update_adelantos.fechaInicioContrato = this.datePipe.transform(this.update_adelantos.fechaInicioContrato, 'yyyy-MM-dd');
      this.adelantoService.actualizarAdelanto(this.update_adelantos).subscribe(res => {
        if (res.success === true) {
          this.alert.success_small(res.msg!);
          this.modalReference.close();
          this.debouncer.next(true);
        } else {
          this.alert.error_small(res.msg!);
        }
      });
    } else {
      this.alert.error_small("Por favor, completa todos los campos.");
    }
  }
  eliminar_adelanto(content: any, id: number) {
    Swal.fire({
      title: 'Eliminar?',
      text: "Se eliminara el adelanto",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#ff0000',
      cancelButtonColor: '#6c736e',
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Eliminar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.adelantoService.eliminarAdelanto(id).subscribe(res => {
          if (res.success === true) {
            this.alert.success_small(res.msg!);
            this.debouncer.next(true);
          } else {
            this.alert.error_small(res.msg!);
          }
        });
      }
    });
  }

  ObtenerTrabajador(event: MatSelectChange) {
    this.update_adelantos.fk_trabajador = event.value;
  }

  ObtenerEmpresa(event: MatSelectChange) {
    this.update_adelantos.empresa = event.value;
  }

  ObtenerBanco(event: MatSelectChange) {
    this.update_adelantos.banco = event.value;
  }

  applyFilters() {
    console.log(this.dateRangeForm.value);
    const empresaId = this.dateRangeForm.get('empresa')?.value;
    console.log("empresaId: ", empresaId);
    const { start, end } = this.dateRangeForm.value;
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      const isInEmpresa = !empresaId || data.Empresa.id === empresaId;
      const isInDateRange = (!start || new Date(data.fechaInicioContrato) >= new Date(start)) &&
        (!end || new Date(data.fechaInicioContrato) <= new Date(end));
      return isInEmpresa && isInDateRange;
    };

    this.dataSource.filter = JSON.stringify({ empresaId, start, end });
  }

  clearFilters() {
    this.dateRangeForm.reset();
    this.dataSource.filter = '';
  }

  onDateRangeChange(event: MatDatepickerInputEvent<Date>) {
    this.applyFilters();
  }
}
